export default __webpack_public_path__ + "static/media/icon-tick.4c69157a.svg";